import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { Dismiss24Filled } from "@fluentui/react-icons";
import React from "react";
import { toast } from "react-toastify";


type CollaborationPurchasedDialogProps = {
    isOpened?: boolean,
    hideCloseButton?: boolean,
    onClose: () => void;
};

export const CollaborationPurchasedDialog: React.FC<CollaborationPurchasedDialogProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(!!props.isOpened);

    }, [props.isOpened]);



    const onModalClose = () => {
        setOpen(false);
        if (props.onClose)
            props.onClose();
    }

    return (<Dialog open={open} onOpenChange={(event, data) => {

        setOpen(data.open);
        if (!data.open) {
            onModalClose();
        }

    }}>
        <DialogSurface>

            <DialogBody>
                <DialogTitle
                    style={{ textAlign: "center", paddingLeft: "32px" }}
                    action={<Button appearance="transparent" onClick={onModalClose} icon={<Dismiss24Filled />} />}>Thank you for subscribing</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "10px 0px" }}>
                        <span >To use the feature go to </span>
                        <span> DWSIM - Tools - Activate Collaboration</span>
                    </div>

                </DialogContent>
                {!props.hideCloseButton && <DialogActions>
                    <Button appearance="secondary" onClick={onModalClose}>Close</Button>
                </DialogActions>}
            </DialogBody>

        </DialogSurface>
    </Dialog>);
}